import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

// TODO: Reemplazar los placeholders [INSERTAR_...] con los datos reales de Coralan Multiservice SRL
// antes del deploy a producción.
const TerminosDeUso = () => {
    return (
        <LegalPageLayout
            seoTitle="Términos de Uso"
            path="/terminos-de-uso"
            description="Términos y condiciones de uso de la plataforma de facturación electrónica y de los servicios de Coralan Multiservice SRL."
            breadcrumbLabel="Términos de Uso"
            title="Términos de Uso"
            subtitle="Condiciones de uso de la plataforma de Facturación Electrónica de Coralan Multiservice SRL."
            lastUpdated="Enero 2026"
        >
            <div className="legal-page__content">
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">1.</span>
                        Aceptación de los Términos
                    </h2>
                    <p>
                        Al acceder y utilizar los servicios de Facturación Electrónica de
                        Coralan Multiservice SRL, usted acepta cumplir con estos Términos
                        de Uso. Si no está de acuerdo, le pedimos que no utilice nuestros
                        servicios.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">2.</span>
                        Descripción del Servicio
                    </h2>
                    <p>
                        Coralan Multiservice SRL es un Proveedor de Servicios de Facturación
                        Electrónica autorizado por la Dirección General de Impuestos Internos
                        (DGII) de la República Dominicana. Nuestros servicios incluyen:
                    </p>
                    <ul>
                        <li>
                            Plataforma de generación y emisión de Comprobantes Fiscales
                            Electrónicos (e-CF).
                        </li>
                        <li>Integración con los sistemas de la DGII.</li>
                        <li>Almacenamiento y consulta de comprobantes emitidos.</li>
                        <li>Soporte técnico y asistencia a contribuyentes.</li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">3.</span>
                        Obligaciones del Usuario
                    </h2>
                    <p>El contribuyente usuario se compromete a:</p>
                    <ul>
                        <li>
                            Proporcionar información veraz y actualizada al momento del
                            registro.
                        </li>
                        <li>
                            Utilizar el servicio únicamente para fines legítimos conforme al
                            Código Tributario.
                        </li>
                        <li>Custodiar de forma segura sus credenciales de acceso.</li>
                        <li>No compartir sus credenciales con terceros no autorizados.</li>
                        <li>
                            Notificar de inmediato cualquier uso no autorizado de su cuenta.
                        </li>
                        <li>
                            Mantener su Certificado Digital vigente y en buen estado.
                        </li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">4.</span>
                        Disponibilidad del Servicio
                    </h2>
                    <p>
                        Coralan Multiservice SRL garantiza una disponibilidad del servicio
                        de <strong>99.5% mensual</strong>. Nos reservamos el derecho de
                        realizar mantenimientos programados, notificados con al menos
                        <strong> 48 horas de anticipación</strong>.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">5.</span>
                        Propiedad Intelectual
                    </h2>
                    <p>
                        Todo el software, código, diseño y documentación de la plataforma
                        son propiedad exclusiva de Coralan Multiservice SRL. Queda prohibida
                        su reproducción total o parcial sin autorización expresa y por escrito.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">6.</span>
                        Limitación de Responsabilidad
                    </h2>
                    <p>Coralan Multiservice SRL no será responsable por:</p>
                    <ul>
                        <li>
                            Daños derivados del uso incorrecto de las credenciales por parte
                            del usuario.
                        </li>
                        <li>
                            Interrupciones del servicio causadas por fuerza mayor o terceros.
                        </li>
                        <li>
                            Errores en la información proporcionada por el contribuyente al
                            momento de emitir e-CF.
                        </li>
                    </ul>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">7.</span>
                        Confidencialidad
                    </h2>
                    <p>
                        Toda la información fiscal y los datos personales de los
                        contribuyentes son tratados de forma confidencial conforme a la
                        Ley Núm. 172-13 y la Ley Núm. 32-23.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">8.</span>
                        Modificaciones
                    </h2>
                    <p>
                        Coralan Multiservice SRL se reserva el derecho de modificar estos
                        Términos de Uso. Los cambios serán publicados en este sitio web con
                        indicación de la fecha de actualización. El uso continuado del
                        servicio implica la aceptación de los términos vigentes.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">9.</span>
                        Ley Aplicable y Jurisdicción
                    </h2>
                    <p>
                        Estos Términos de Uso se rigen por las leyes de la República
                        Dominicana. Cualquier controversia será sometida a los tribunales
                        competentes de Santo Domingo, República Dominicana.
                    </p>
                </div>

                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">10.</span>
                        Contacto
                    </h2>
                    <p>Para consultas sobre estos términos:</p>
                    <ul>
                        <li>Correo: <strong>info@coralanmultiservice.com</strong></li>
                        <li>Teléfono: <strong>809-605-0699</strong></li>
                        <li>
                            Dirección: <strong>C/San Juan Bautista de la Salle #17, Mirador Norte</strong>, Santo Domingo,
                            República Dominicana.
                        </li>
                    </ul>
                </div>

                <div className="legal-page__cta">
                    <div className="legal-page__cta-text">
                        <p className="legal-page__cta-title">
                            ¿Dudas sobre tu plan o contrato?
                        </p>
                        <p className="legal-page__cta-subtitle">
                            Nuestro equipo de soporte responde cualquier consulta legal o técnica.
                        </p>
                    </div>
                    <Link to="/soporte" className="legal-page__cta-btn">
                        Ir a Soporte <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </LegalPageLayout>
    );
};

export default TerminosDeUso;
